import request from './Interceptor.js'

//产品菜单栏
export function getCateListProduct(params){
  return request({
    url:'/api/cate/getCateListProduct',
    method :'get',
    params:params,
  })
}
// 获取产品列表
export function getProductList(params) {
  return request({
    url:'/api/product/ProductList',
    method :'get',
    params:params,
  })
}
// 获取产品详情
export function getProductInfo(params) {
  return request({
    url:'/api/Product/getProduct',
    method :'get',
    params:params,
  })
}
// 应用菜单栏
export function getCateListApplication(params){
  return request({
    url:'/api/cate/getCateListApplication',
    method :'get',
    params:params,
  })
}
// 获取菜单栏详情
export function getCateDetailInfo(params){
  return request({
    url:'/api/cate/getCateDetailInfo',
    method :'get',
    params:params,
  })
}
// 企业宣传册列表
export function companyPdfList(params){
  return request({
    url:'/api/atta/companyPdfList',
    method :'get',
    params:params,
  })
}
// 公司视频列表
export function companyVideoList(params){
  return request({
    url:'/api/atta/companyVideoList',
    method :'get',
    params:params,
  })
}
export function getProductQuestion(params){
  return request({
    url:'/api/Product/getProductQuestion',
    method :'get',
    params:params,
  })
}
// 提交问题反馈
export function submitProductQuestionFeedback(params) {
  return request({
    url:'/api/Product/productQuestionFeedback',
    method :'post',
    data:params,
  })
}
export function getCaseList(params){
  return request({
    url:'/api/cases/getCaseList',
    method :'get',
    params:params,
  })
}
// 根据关键字模糊查询数据列表
export function getDataListByKeywordQuery(params) {
  return request({
    url:'/api/common/searchinfo',
    method :'get',
    params:params,
  })
}
export function getCase(params){
  return request({
    url:'/api/cases/getCase',
    method :'get',
    params:params,
  })
}
// 提交在线留言
export function postAdvise(params){
  return request({
    // url:'/api/advise/postAdvise',
    url: '/api/leavemessage/postAdvise',
    method :'post',
    data:params,
  })
}
// 在线留言内容详情查询
export function getMessageApi(params) {
  return request({
    url: '/api/leavemessage/getmessage',
    method :'post',
    data: params,
  })
}
// 在线留言回复
export function messageReplyApi(params) {
  return request({
    url: '/api/leavemessage/replymessage',
    method :'post',
    data: params,
  })
}

// 检查系统中是否已经存在当前邮箱
export function checkEmailApi(params) {
  return request({
    url: '/api/leavemessage/checkEmail',
    method: 'post',
    params: params
  })
}
// 获取邮箱验证码
export function sendEmail(params){
  return request({
    url:'/api/common/sendEmail',
    method :'post',
    params:params,
  })
}
// 检测投诉邮箱
export function checkemail(params){
  return request({
    url:'/api/advise/checkemail',
    method :'post',
    params:params,
  })
}
// 获取首页轮播图
export function getBanner(params){
  return request({
    url:'/api/common/getconfig',
    method :'get',
    params:params,
  })
}
// 获取大事件
export function getArticleList(params){
  return request({
    url:'/api/article/getArticleList',
    method :'get',
    params:params,
  })
}
// 获取首页公共数据
export function getConfigDataApi(){
  return request({
    url:'/api/common/getconfig',
    method :'get',
    params:{
      configname: "site"
    },
  })
}

// 获取招聘信息
export function getZhaoPingList(params) {
  return request({
    url:'/api/recruiting/index',
    method :'get',
    params:params,
  })
}


// WEBPACK FOOTER //
// ./src/utils/http.js